import { alpha, Box, Hidden, Typography, useTheme } from "@mui/material";
import LoginPanel from "../components/Login/Panel";
import { useTranslation } from "react-i18next";

const Login: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box display="flex" sx={{ height: "100vh", bgcolor: "background.default" }}>
      <LoginPanel />

      <Hidden smDown>
        <Box
          display="flex"
          flexGrow={2}
          height="100%"
          sx={{
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            overflow: "auto",
            position: "relative",
          }}
        >
          {/* Decorative circles */}
          <Box
            sx={{
              position: "absolute",
              top: -100,
              right: -100,
              width: 400,
              height: 400,
              borderRadius: "50%",
              bgcolor: alpha(theme.palette.common.white, 0.05),
            }}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: -60,
              left: -60,
              width: 300,
              height: 300,
              borderRadius: "50%",
              bgcolor: alpha(theme.palette.common.white, 0.04),
            }}
          />

          <Box
            display="flex"
            flexDirection="column"
            width="100%"
            height="100%"
            alignItems="center"
            justifyContent="center"
            sx={{ position: "relative", zIndex: 1, px: 4 }}
          >
            <Typography
              variant="h2"
              color="common.white"
              fontWeight={800}
              sx={{ letterSpacing: -1 }}
            >
              {t("appName")}
            </Typography>

            <Typography
              variant="h5"
              color="common.white"
              align="center"
              mt={2}
              sx={{ opacity: 0.85, maxWidth: 400, lineHeight: 1.5 }}
            >
              {t("login.statement")}
            </Typography>

            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              mt={6}
              mb={4}
            >
              <img
                width="60%"
                style={{
                  maxWidth: 500,
                  filter: "drop-shadow(0 20px 40px rgba(0,0,0,0.3))",
                }}
                src="/devices.54f72a42.webp"
                alt="eParentSpace"
              />
            </Box>

            <Box display="flex" gap={2} justifyContent="center" maxWidth={320}>
              <img
                width="45%"
                src="/play-store.5b9aea57.svg"
                alt="Play Store"
                style={{ cursor: "pointer", transition: "transform 0.2s" }}
              />
              <img
                width="45%"
                src="/app-store.555edf48.svg"
                alt="App Store"
                style={{ cursor: "pointer", transition: "transform 0.2s" }}
              />
            </Box>
          </Box>
        </Box>
      </Hidden>
    </Box>
  );
};

export default Login;
